import React, { useEffect } from 'react';
import useAuth from '../../hooks/context/useAuth';
import { useNavigate } from 'react-router';
import { Routes } from '../../routing/Router';
import { Button, Card, Flex, Form, Input } from 'antd';
import useData from '../../hooks/utility/useData';
import { LoginRequestParams } from '../../services/api/AuthService';
import useNotification from '../../hooks/context/useNotification';

export default function LoginPage() {
  const { loading, isLoggedIn, logIn } = useAuth();
  const navigate = useNavigate();
  const { notificationApi } = useNotification();

  const { data, updateData } = useData<LoginRequestParams>({
    email: null,
    password: null,
  });

  useEffect(() => {
    isLoggedIn && navigate(`/${Routes.NewOrder.Root}`);
  }, []);

  const onLogin = () => {
    const onError = (error: Error) => {
      notificationApi.error({ message: 'Failed to log in' });
      console.error('Failed to log in', { error });
    };

    logIn(data)
      .then(() => navigate(`/${Routes.NewOrder.Root}`))
      .catch(onError);
  };

  return (
    <div className="h-screen flex">
      <Card className="w-1/3 m-auto">
        <Form layout="vertical">
          <Form.Item label="Email" required>
            <Input value={data.email} onChange={(e) => updateData('email', e.target.value)} />
          </Form.Item>
          <Form.Item label="Password" required>
            <Input.Password
              value={data.password}
              onChange={(e) => updateData('password', e.target.value)}
            />
          </Form.Item>
        </Form>
        <Flex justify="end">
          <Button type="primary" onClick={onLogin} loading={loading}>
            Login
          </Button>
        </Flex>
      </Card>
    </div>
  );
}
